import { doGet, doPost } from 'hooks/requests';

export const useInvoicesService = () => {
    const getWatchLists = (data) => {
        const params = new URLSearchParams({
            company_id: data.companyId,
            page: data.page || 1,
            eventDays: 20,
            ...(data.status && { status: data.status }),
            ...(data.fullfillment && { fullfillment: data.fullfillment }),
            ...(data.marketplace && { marketplace: data.marketplace }),
            ...(data.startDate && { startDate: data.startDate }),
            ...(data.endDate && { endDate: data.endDate }),
            ...(data.sortColumn && { sortColumn: data.sortColumn }),
            ...(data.sortOrder && { sortOrder: data.sortOrder }),
            ...(data.customer && { customer: data.customer }),
        });
        return doGet(`invoice/watchlist/?${params.toString()}`);
    };

    const getInvoiceFiles = (data) => {
        const params = new URLSearchParams({
            company_id: data.companyId,
            status: data.status,
        });
        return doGet(`invoice/get-files/?${params.toString()}`);
    };

    const addInvoiceFile = (data) => {
        return doPost('invoice/add-file/', data);
    };

    return {
        getWatchLists,
        addInvoiceFile,
        getInvoiceFiles,
    };
};
